import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ScopeLevel } from '@bingads-webui-campaign-react/constants';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getGridStyles } from './style';

export const SwitchUseCampaignSetting = ({ data, onDataChange, level }) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getGridStyles);
  const onChange = useCallback(
    (ev, { checked }) => {
      onDataChange({
        ...data,
        useParentLevel: checked,
      });
    },
    [data, onDataChange]
  );

  if (level === ScopeLevel.Campaign) {
    return null;
  }

  return (
    <Switch
      checked={data.useParentLevel}
      onChange={onChange}
      label={i18n.getString(_TL_('Use my campaign settings'))}
      className={classes.switch}
    />
  );
};

SwitchUseCampaignSetting.propTypes = {
  onDataChange: PropTypes.func.isRequired,
  data: PropTypes.shape({
    useParentLevel: PropTypes.bool,
  }).isRequired,
  level: PropTypes.string.isRequired,
};
